export const clientFlights: any[] = [
  {
    Client: 'EL AL Israel Airlines',
    'Flight name': 'TLV - EWR',
    'Origin Airport': 'Ben Gurion Intl',
    'Destination Airport': 'Newark International Airport',
    'Origin city': 'Tel-aviv',
    'Destination City': 'New York',
    'Origin country': 'Israel',
    'Destination country': 'USA',
    'Flight ID': 'LY315',
    'Flight due date': '11/29/24',
    'Departure time': '9:05 am',
    'Arrival time': '12:35 pm',
    'Flight Duration': '5h 30m',
    'Arrival type': 'Noon',
    'Flight date finish': '11/29/24',
    'My Price': '220',
    'Last Scan': '15/04/2024',
    'Cabin baggage price': null,
    'Checked baggae price': '90$',
    Aircraft: 'Boeing 787-9 Dreamliner',
  },
  {
    Client: 'EL AL Israel Airlines',
    'Flight name': 'TLV - EWR',
    'Origin Airport': 'Ben Gurion Intl',
    'Destination Airport': 'Newark International Airport',
    'Origin city': 'Tel-aviv',
    'Destination City': 'New York',
    'Origin country': 'Israel',
    'Destination country': 'USA',
    'Flight ID': 'LY315',
    'Flight due date': '11/29/24',
    'Departure time': '9:05 am',
    'Arrival time': '12:35 pm',
    'Flight Duration': '5h 30m',
    'Arrival type': 'Noon',
    'Flight date finish': '11/29/24',
    'My Price': '180',
    'Last Scan': '15/04/2024',
    'Cabin baggage price': null,
    'Checked baggae price': '90$',
    Aircraft: 'Boeing 787-9 Dreamliner',
  },
  {
    Client: 'EL AL Israel Airlines',
    'Flight name': 'TLV - LHR',
    'Origin Airport': 'Ben Gurion Intl',
    'Destination Airport': 'London Heathrow',
    'Origin city': 'Tel-aviv',
    'Destination City': 'London',
    'Origin country': 'Israel',
    'Destination country': 'United kingdom',
    'Flight ID': 'LY315',
    'Flight due date': '11/29/24',
    'Departure time': '9:05 am',
    'Arrival time': '12:35 pm',
    'Flight Duration': '5h 30m',
    'Arrival type': 'Noon',
    'Flight date finish': '11/29/24',
    'My Price': '220',
    'Last Scan': '15/04/2024',
    'Cabin baggage price': null,
    'Checked baggae price': '90$',
    Aircraft: 'Boeing 787-9 Dreamliner',
  },
  {
    Client: 'EL AL Israel Airlines',
    'Flight name': 'TLV - LHR',
    'Origin Airport': 'Ben Gurion Intl',
    'Destination Airport': 'London Heathrow',
    'Origin city': 'Tel-aviv',
    'Destination City': 'London',
    'Origin country': 'Israel',
    'Destination country': 'United kingdom',
    'Flight ID': 'LY317',
    'Flight due date': '11/29/24',
    'Departure time': '5:15 pm',
    'Arrival time': '8:45 pm',
    'Flight Duration': '5h 30m',
    'Arrival type': 'Evening',
    'Flight date finish': '11/29/24',
    'My Price': '200',
    'Last Scan': '15/04/2024',
    'Cabin baggage price': null,
    'Checked baggae price': '90$',
    Aircraft: 'Boeing 777-200/200ER',
  },
  {
    Client: 'EL AL Israel Airlines',
    'Flight name': 'TLV - LHR',
    'Origin Airport': 'Ben Gurion Intl',
    'Destination Airport': 'London Heathrow',
    'Origin city': 'Tel-aviv',
    'Destination City': 'London',
    'Origin country': 'Israel',
    'Destination country': 'United kingdom',
    'Flight ID': 'LY315',
    'Flight due date': '11/30/24',
    'Departure time': '9:05 am',
    'Arrival time': '12:35 pm',
    'Flight Duration': '5h 30m',
    'Arrival type': 'Noon',
    'Flight date finish': '11/30/24',
    'My Price': '190',
    'Last Scan': '15/04/2024',
    'Cabin baggage price': null,
    'Checked baggae price': '90$',
    Aircraft: 'Boeing 787-9 Dreamliner',
  },
  {
    Client: 'EL AL Israel Airlines',
    'Flight name': 'TLV - LHR',
    'Origin Airport': 'Ben Gurion Intl',
    'Destination Airport': 'London Heathrow',
    'Origin city': 'Tel-aviv',
    'Destination City': 'London',
    'Origin country': 'Israel',
    'Destination country': 'United kingdom',
    'Flight ID': 'LY317',
    'Flight due date': '11/30/24',
    'Departure time': '5:15 pm',
    'Arrival time': '8:45 pm',
    'Flight Duration': '5h 30m',
    'Arrival type': 'Evening',
    'Flight date finish': '11/30/24',
    'My Price': '160',
    'Last Scan': '15/04/2024',
    'Cabin baggage price': null,
    'Checked baggae price': '90$',
    Aircraft: 'Boeing 787-8 Dreamliner',
  },
  {
    Client: 'EL AL Israel Airlines',
    'Flight name': 'TLV - LHR',
    'Origin Airport': 'Ben Gurion Intl',
    'Destination Airport': 'London Heathrow',
    'Origin city': 'Tel-aviv',
    'Destination City': 'London',
    'Origin country': 'Israel',
    'Destination country': 'United kingdom',
    'Flight ID': 'LY315',
    'Flight due date': '12/1/24',
    'Departure time': '9:05 am',
    'Arrival time': '12:35 pm',
    'Flight Duration': '5h 30m',
    'Arrival type': 'Noon',
    'Flight date finish': '12/1/24',
    'My Price': '250',
    'Last Scan': '15/04/2024',
    'Cabin baggage price': null,
    'Checked baggae price': '90$',
    Aircraft: 'Boeing 787-9 Dreamliner',
  },
  {
    Client: 'EL AL Israel Airlines',
    'Flight name': 'TLV - LHR',
    'Origin Airport': 'Ben Gurion Intl',
    'Destination Airport': 'London Heathrow',
    'Origin city': 'Tel-aviv',
    'Destination City': 'London',
    'Origin country': 'Israel',
    'Destination country': 'United kingdom',
    'Flight ID': 'LY317',
    'Flight due date': '12/1/24',
    'Departure time': '5:15 pm',
    'Arrival time': '8:45 pm',
    'Flight Duration': '5h 30m',
    'Arrival type': 'Evening',
    'Flight date finish': '12/1/24',
    'My Price': '270',
    'Last Scan': '15/04/2024',
    'Cabin baggage price': null,
    'Checked baggae price': '90$',
    Aircraft: 'Boeing 777-200/200ER',
  },
  {
    Client: 'EL AL Israel Airlines',
    'Flight name': 'TLV - LHR',
    'Origin Airport': 'Ben Gurion Intl',
    'Destination Airport': 'London Heathrow',
    'Origin city': 'Tel-aviv',
    'Destination City': 'London',
    'Origin country': 'Israel',
    'Destination country': 'United kingdom',
    'Flight ID': 'LY315',
    'Flight due date': '12/2/24',
    'Departure time': '9:05 am',
    'Arrival time': '12:35 pm',
    'Flight Duration': '5h 30m',
    'Arrival type': 'Noon',
    'Flight date finish': '12/2/24',
    'My Price': '280',
    'Last Scan': '15/04/2024',
    'Cabin baggage price': null,
    'Checked baggae price': '90$',
    Aircraft: 'Boeing 787-9 Dreamliner',
  },
  {
    Client: 'EL AL Israel Airlines',
    'Flight name': 'TLV - LHR',
    'Origin Airport': 'Ben Gurion Intl',
    'Destination Airport': 'London Heathrow',
    'Origin city': 'Tel-aviv',
    'Destination City': 'London',
    'Origin country': 'Israel',
    'Destination country': 'United kingdom',
    'Flight ID': 'LY317',
    'Flight due date': '12/2/24',
    'Departure time': '5:15 pm',
    'Arrival time': '8:45 pm',
    'Flight Duration': '5h 30m',
    'Arrival type': 'Evening',
    'Flight date finish': '12/2/24',
    'My Price': '220',
    'Last Scan': '15/04/2024',
    'Cabin baggage price': null,
    'Checked baggae price': '90$',
    Aircraft: 'Boeing 787-8 Dreamliner',
  },
  {
    Client: 'EL AL Israel Airlines',
    'Flight name': 'TLV - LHR',
    'Origin Airport': 'Ben Gurion Intl',
    'Destination Airport': 'London Heathrow',
    'Origin city': 'Tel-aviv',
    'Destination City': 'London',
    'Origin country': 'Israel',
    'Destination country': 'United kingdom',
    'Flight ID': 'LY315',
    'Flight due date': '12/3/24',
    'Departure time': '9:05 am',
    'Arrival time': '12:35 pm',
    'Flight Duration': '5h 30m',
    'Arrival type': 'Noon',
    'Flight date finish': '12/3/24',
    'My Price': '100',
    'Last Scan': '15/04/2024',
    'Cabin baggage price': null,
    'Checked baggae price': '90$',
    Aircraft: 'Boeing 787-9 Dreamliner',
  },
  {
    Client: 'EL AL Israel Airlines',
    'Flight name': 'TLV - LHR',
    'Origin Airport': 'Ben Gurion Intl',
    'Destination Airport': 'London Heathrow',
    'Origin city': 'Tel-aviv',
    'Destination City': 'London',
    'Origin country': 'Israel',
    'Destination country': 'United kingdom',
    'Flight ID': 'LY317',
    'Flight due date': '12/3/24',
    'Departure time': '5:15 pm',
    'Arrival time': '8:45 pm',
    'Flight Duration': '5h 30m',
    'Arrival type': 'Evening',
    'Flight date finish': '12/3/24',
    'My Price': '120',
    'Last Scan': '15/04/2024',
    'Cabin baggage price': null,
    'Checked baggae price': '90$',
    Aircraft: 'Boeing 787-9 Dreamliner',
  },
  {
    Client: 'EL AL Israel Airlines',
    'Flight name': 'TLV - LHR',
    'Origin Airport': 'Ben Gurion Intl',
    'Destination Airport': 'London Heathrow',
    'Origin city': 'Tel-aviv',
    'Destination City': 'London',
    'Origin country': 'Israel',
    'Destination country': 'United kingdom',
    'Flight ID': 'LY315',
    'Flight due date': '12/4/24',
    'Departure time': '9:05 am',
    'Arrival time': '12:35 pm',
    'Flight Duration': '5h 30m',
    'Arrival type': 'Noon',
    'Flight date finish': '12/4/24',
    'My Price': '280',
    'Last Scan': '15/04/2024',
    'Cabin baggage price': null,
    'Checked baggae price': '90$',
    Aircraft: 'Boeing 777-200/200ER',
  },
  {
    Client: 'EL AL Israel Airlines',
    'Flight name': 'TLV - LTN',
    'Origin Airport': 'Ben Gurion Intl',
    'Destination Airport': 'London Luton',
    'Origin city': 'Tel-aviv',
    'Destination City': 'London',
    'Origin country': 'Israel',
    'Destination country': 'United kingdom',
    'Flight ID': 'LY311',
    'Flight due date': '12/2/24',
    'Departure time': '7:00 am',
    'Arrival time': '10:30 am',
    'Flight Duration': '5h 30m',
    'Arrival type': 'Morning',
    'Flight date finish': '12/2/24',
    'My Price': '190',
    'Last Scan': '15/04/2024',
    'Cabin baggage price': null,
    'Checked baggae price': '90$',
    Aircraft: 'Boeing 737-800',
  },
  {
    Client: 'EL AL Israel Airlines',
    'Flight name': 'TLV - LTN',
    'Origin Airport': 'Ben Gurion Intl',
    'Destination Airport': 'London Luton',
    'Origin city': 'Tel-aviv',
    'Destination City': 'London',
    'Origin country': 'Israel',
    'Destination country': 'United kingdom',
    'Flight ID': 'LY311',
    'Flight due date': '12/3/24',
    'Departure time': '5:30 am',
    'Arrival time': '9:00 am',
    'Flight Duration': '5h 30m',
    'Arrival type': 'Morning',
    'Flight date finish': '12/3/24',
    'My Price': '190',
    'Last Scan': '15/04/2024',
    'Cabin baggage price': null,
    'Checked baggae price': '90$',
    Aircraft: 'Boeing 737-800',
  },
  {
    Client: 'EL AL Israel Airlines',
    'Flight name': 'TLV - LTN',
    'Origin Airport': 'Ben Gurion Intl',
    'Destination Airport': 'London Luton',
    'Origin city': 'Tel-aviv',
    'Destination City': 'London',
    'Origin country': 'Israel',
    'Destination country': 'United kingdom',
    'Flight ID': 'LY311',
    'Flight due date': '12/4/24',
    'Departure time': '3:10 am',
    'Arrival time': '6:40 am',
    'Flight Duration': '5h 30m',
    'Arrival type': 'Morning',
    'Flight date finish': '12/4/24',
    'My Price': '189',
    'Last Scan': '15/04/2024',
    'Cabin baggage price': null,
    'Checked baggae price': '90$',
    Aircraft: 'Boeing 737-800',
  },
  {
    Client: 'EL AL Israel Airlines',
    'Flight name': 'TLV - MXP',
    'Origin Airport': 'Ben Gurion Intl',
    'Destination Airport': 'Milan Malpensa',
    'Origin city': 'Tel-aviv',
    'Destination City': 'Milan',
    'Origin country': 'Israel',
    'Destination country': 'Italy',
    'Flight ID': 'LY381',
    'Flight due date': '11/29/24',
    'Departure time': '6:50 am',
    'Arrival time': '10:05 am',
    'Flight Duration': '4h 15m',
    'Arrival type': 'Morning',
    'Flight date finish': '11/29/24',
    'My Price': '171',
    'Last Scan': '15/04/2024',
    'Cabin baggage price': null,
    'Checked baggae price': '90$',
    Aircraft: 'Boeing 737-900',
  },
  {
    Client: 'EL AL Israel Airlines',
    'Flight name': 'TLV - MXP',
    'Origin Airport': 'Ben Gurion Intl',
    'Destination Airport': 'Milan Malpensa',
    'Origin city': 'Tel-aviv',
    'Destination City': 'Milan',
    'Origin country': 'Israel',
    'Destination country': 'Italy',
    'Flight ID': 'LY387',
    'Flight due date': '11/29/24',
    'Departure time': '5:40 pm',
    'Arrival time': '8:55 pm',
    'Flight Duration': '4h 15m',
    'Arrival type': 'Evening',
    'Flight date finish': '11/29/24',
    'My Price': '170',
    'Last Scan': '15/04/2024',
    'Cabin baggage price': null,
    'Checked baggae price': '90$',
    Aircraft: 'Boeing 737-900',
  },
  {
    Client: 'EL AL Israel Airlines',
    'Flight name': 'TLV - MXP',
    'Origin Airport': 'Ben Gurion Intl',
    'Destination Airport': 'Milan Malpensa',
    'Origin city': 'Tel-aviv',
    'Destination City': 'Milan',
    'Origin country': 'Israel',
    'Destination country': 'Italy',
    'Flight ID': 'LY381',
    'Flight due date': '11/30/24',
    'Departure time': '6:50 am',
    'Arrival time': '10:05 am',
    'Flight Duration': '4h 15m',
    'Arrival type': 'Morning',
    'Flight date finish': '11/30/24',
    'My Price': '260',
    'Last Scan': '15/04/2024',
    'Cabin baggage price': null,
    'Checked baggae price': '90$',
    Aircraft: 'Boeing 737-900',
  },
  {
    Client: 'EL AL Israel Airlines',
    'Flight name': 'TLV - MXP',
    'Origin Airport': 'Ben Gurion Intl',
    'Destination Airport': 'Milan Malpensa',
    'Origin city': 'Tel-aviv',
    'Destination City': 'Milan',
    'Origin country': 'Israel',
    'Destination country': 'Italy',
    'Flight ID': 'LY387',
    'Flight due date': '11/30/24',
    'Departure time': '3:55 pm',
    'Arrival time': '7:05 pm',
    'Flight Duration': '4h 10m',
    'Arrival type': 'Evening',
    'Flight date finish': '11/30/24',
    'My Price': '180',
    'Last Scan': '15/04/2024',
    'Cabin baggage price': null,
    'Checked baggae price': '90$',
    Aircraft: 'Boeing 737-800',
  },
  {
    Client: 'EL AL Israel Airlines',
    'Flight name': 'TLV - MXP',
    'Origin Airport': 'Ben Gurion Intl',
    'Destination Airport': 'Milan Malpensa',
    'Origin city': 'Tel-aviv',
    'Destination City': 'Milan',
    'Origin country': 'Israel',
    'Destination country': 'Italy',
    'Flight ID': 'LY381',
    'Flight due date': '12/3/24',
    'Departure time': '6:50 am',
    'Arrival time': '10:05 am',
    'Flight Duration': '4h 15m',
    'Arrival type': 'Morning',
    'Flight date finish': '12/3/24',
    'My Price': '171',
    'Last Scan': '15/04/2024',
    'Cabin baggage price': null,
    'Checked baggae price': '90$',
    Aircraft: 'Boeing 737-900',
  },
  {
    Client: 'EL AL Israel Airlines',
    'Flight name': 'TLV - CDG',
    'Origin Airport': 'Ben Gurion Intl',
    'Destination Airport': 'Paris Charles de Gaulle',
    'Origin city': 'Tel-aviv',
    'Destination City': 'Paris',
    'Origin country': 'Israel',
    'Destination country': 'France',
    'Flight ID': 'LY325',
    'Flight due date': '11/30/24',
    'Departure time': '4:50 pm',
    'Arrival time': '8:55 pm',
    'Flight Duration': '5h 05m',
    'Arrival type': 'Evening',
    'Flight date finish': '11/30/24',
    'My Price': '222',
    'Last Scan': '15/04/2024',
    'Cabin baggage price': null,
    'Checked baggae price': '90$',
    Aircraft: 'Boeing 737-900',
  },
  {
    Client: 'EL AL Israel Airlines',
    'Flight name': 'TLV - CDG',
    'Origin Airport': 'Ben Gurion Intl',
    'Destination Airport': 'Paris Charles de Gaulle',
    'Origin city': 'Tel-aviv',
    'Destination City': 'Paris',
    'Origin country': 'Israel',
    'Destination country': 'France',
    'Flight ID': 'LY325',
    'Flight due date': '12/1/24',
    'Departure time': '4:50 pm',
    'Arrival time': '8:55 pm',
    'Flight Duration': '5h 05m',
    'Arrival type': 'Evening',
    'Flight date finish': '12/1/24',
    'My Price': '250',
    'Last Scan': '15/04/2024',
    'Cabin baggage price': null,
    'Checked baggae price': '90$',
    Aircraft: 'Boeing 737-900',
  },
  {
    Client: 'EL AL Israel Airlines',
    'Flight name': 'TLV - AMS',
    'Origin Airport': 'Ben Gurion Intl',
    'Destination Airport': 'AMS Amsterdam',
    'Origin city': 'Tel-aviv',
    'Destination City': 'Amsterdam',
    'Origin country': 'Israel',
    'Destination country': 'Netherlands',
    'Flight ID': 'LY339',
    'Flight due date': '11/30/24',
    'Departure time': '4:10 pm',
    'Arrival time': '8:20 pm',
    'Flight Duration': '5h 10m',
    'Arrival type': 'Evening',
    'Flight date finish': '11/30/24',
    'My Price': '230',
    'Last Scan': '15/04/2024',
    'Cabin baggage price': null,
    'Checked baggae price': '90$',
    Aircraft: 'Boeing 737-900',
  },
  {
    Client: 'EL AL Israel Airlines',
    'Flight name': 'TLV - AMS',
    'Origin Airport': 'Ben Gurion Intl',
    'Destination Airport': 'AMS Amsterdam',
    'Origin city': 'Tel-aviv',
    'Destination City': 'Amsterdam',
    'Origin country': 'Israel',
    'Destination country': 'Netherlands',
    'Flight ID': 'LY339',
    'Flight due date': '12/7/24',
    'Departure time': '4:10 pm',
    'Arrival time': '8:20 pm',
    'Flight Duration': '5h 10m',
    'Arrival type': 'Evening',
    'Flight date finish': '12/7/24',
    'My Price': '202',
    'Last Scan': '15/04/2024',
    'Cabin baggage price': null,
    'Checked baggae price': '90$',
    Aircraft: 'Boeing 737-900',
  },
  {
    Client: 'EL AL Israel Airlines',
    'Flight name': 'TLV - WAW',
    'Origin Airport': 'Ben Gurion Intl',
    'Destination Airport': 'Warsaw Chopin',
    'Origin city': 'Tel-aviv',
    'Destination City': 'Warsaw',
    'Origin country': 'Israel',
    'Destination country': 'Polland',
    'Flight ID': 'LY561',
    'Flight due date': '11/29/24',
    'Departure time': '6:15 pm',
    'Arrival time': '9:10 pm',
    'Flight Duration': '3h 55m',
    'Arrival type': 'Evening',
    'Flight date finish': '11/29/24',
    'My Price': '112',
    'Last Scan': '15/04/2024',
    'Cabin baggage price': null,
    'Checked baggae price': '90$',
    Aircraft: 'Boeing 737-900',
  },
  {
    Client: 'EL AL Israel Airlines',
    'Flight name': 'TLV - WAW',
    'Origin Airport': 'Ben Gurion Intl',
    'Destination Airport': 'Warsaw Chopin',
    'Origin city': 'Tel-aviv',
    'Destination City': 'Warsaw',
    'Origin country': 'Israel',
    'Destination country': 'Polland',
    'Flight ID': 'LY561',
    'Flight due date': '12/3/24',
    'Departure time': '5:40 pm',
    'Arrival time': '8:35 pm',
    'Flight Duration': '3h 55m',
    'Arrival type': 'Evening',
    'Flight date finish': '12/3/24',
    'My Price': '150',
    'Last Scan': '15/04/2024',
    'Cabin baggage price': null,
    'Checked baggae price': '90$',
    Aircraft: 'Boeing 737-900',
  },
  {
    Client: 'EL AL Israel Airlines',
    'Flight name': 'TLV - WAW',
    'Origin Airport': 'Ben Gurion Intl',
    'Destination Airport': 'Warsaw Chopin',
    'Origin city': 'Tel-aviv',
    'Destination City': 'Warsaw',
    'Origin country': 'Israel',
    'Destination country': 'Polland',
    'Flight ID': 'LY563',
    'Flight due date': '12/4/24',
    'Departure time': '6:10 am',
    'Arrival time': '9:05 am',
    'Flight Duration': '3h 55m',
    'Arrival type': 'Morning',
    'Flight date finish': '12/4/24',
    'My Price': '112',
    'Last Scan': '15/04/2024',
    'Cabin baggage price': null,
    'Checked baggae price': '90$',
    Aircraft: 'Boeing 737-800',
  },
  {
    Client: 'EL AL Israel Airlines',
    'Flight name': 'TLV - BUD',
    'Origin Airport': 'Ben Gurion Intl',
    'Destination Airport': 'BUD Budapest',
    'Origin city': 'Tel-aviv',
    'Destination City': 'Budapest',
    'Origin country': 'Israel',
    'Destination country': 'Hungary',
    'Flight ID': 'LY2365',
    'Flight due date': '11/29/24',
    'Departure time': '7:05 am',
    'Arrival time': '9:35 am',
    'Flight Duration': '3h 30m',
    'Arrival type': 'Morning',
    'Flight date finish': '11/29/24',
    'My Price': '80',
    'Last Scan': '15/04/2024',
    'Cabin baggage price': null,
    'Checked baggae price': '90$',
    Aircraft: 'Boeing 737-800',
  },
  {
    Client: 'EL AL Israel Airlines',
    'Flight name': 'TLV - BUD',
    'Origin Airport': 'Ben Gurion Intl',
    'Destination Airport': 'BUD Budapest',
    'Origin city': 'Tel-aviv',
    'Destination City': 'Budapest',
    'Origin country': 'Israel',
    'Destination country': 'Hungary',
    'Flight ID': 'LY2367',
    'Flight due date': '11/29/24',
    'Departure time': '5:10 pm',
    'Arrival time': '7:40 pm',
    'Flight Duration': '3h 30m',
    'Arrival type': 'Evening',
    'Flight date finish': '11/29/24',
    'My Price': '95',
    'Last Scan': '15/04/2024',
    'Cabin baggage price': null,
    'Checked baggae price': '90$',
    Aircraft: 'Boeing 737-800',
  },
  {
    Client: 'EL AL Israel Airlines',
    'Flight name': 'TLV - BUD',
    'Origin Airport': 'Ben Gurion Intl',
    'Destination Airport': 'BUD Budapest',
    'Origin city': 'Tel-aviv',
    'Destination City': 'Budapest',
    'Origin country': 'Israel',
    'Destination country': 'Hungary',
    'Flight ID': 'LY2367',
    'Flight due date': '12/3/24',
    'Departure time': '5:10 pm',
    'Arrival time': '7:40 pm',
    'Flight Duration': '3h 30m',
    'Arrival type': 'Evening',
    'Flight date finish': '12/3/24',
    'My Price': '106',
    'Last Scan': '15/04/2024',
    'Cabin baggage price': null,
    'Checked baggae price': '90$',
    Aircraft: 'Boeing 737-800',
  },
  {
    Client: 'EL AL Israel Airlines',
    'Flight name': 'BUD - TLV',
    'Origin Airport': 'BUD Budapest',
    'Destination Airport': 'Ben Gurion Intl',
    'Origin city': 'Budapest',
    'Destination City': 'Tel-aviv',
    'Origin country': 'Hungary',
    'Destination country': 'Israel',
    'Flight ID': 'LY2366',
    'Flight due date': '11/29/24',
    'Departure time': '10:45 am',
    'Arrival time': '2:55 pm',
    'Flight Duration': '3h 10m',
    'Arrival type': 'Morning',
    'Flight date finish': '11/29/24',
    'My Price': '115',
    'Last Scan': '15/04/2024',
    'Cabin baggage price': null,
    'Checked baggae price': '90$',
    Aircraft: 'Boeing 737-800',
  },
  {
    Client: 'EL AL Israel Airlines',
    'Flight name': 'LTN - TLV',
    'Origin Airport': 'London Luton',
    'Destination Airport': 'Ben Gurion Intl',
    'Origin city': 'London',
    'Destination City': 'Tel-aviv',
    'Origin country': 'United kingdom',
    'Destination country': 'Israel',
    'Flight ID': 'LY312',
    'Flight due date': '11/30/24',
    'Departure time': '11:45 am',
    'Arrival time': '6:35 pm',
    'Flight Duration': '4h 50m',
    'Arrival type': 'Evening',
    'Flight date finish': '11/30/24',
    'My Price': '225',
    'Last Scan': '15/04/2024',
    'Cabin baggage price': null,
    'Checked baggae price': '90$',
    Aircraft: 'Boeing 737-800',
  },
  {
    Client: 'EL AL Israel Airlines',
    'Flight name': 'LHR - TLV',
    'Origin Airport': 'London Heathrow',
    'Destination Airport': 'Ben Gurion Intl',
    'Origin city': 'London',
    'Destination City': 'Tel-aviv',
    'Origin country': 'United kingdom',
    'Destination country': 'Israel',
    'Flight ID': 'LY318',
    'Flight due date': '11/30/24',
    'Departure time': '10:20 pm',
    'Arrival time': '5:05 am',
    'Flight Duration': '4h 45m',
    'Arrival type': 'Night',
    'Flight date finish': '12/1/24',
    'My Price': '266',
    'Last Scan': '15/04/2024',
    'Cabin baggage price': null,
    'Checked baggae price': '90$',
    Aircraft: 'Boeing 787-8 Dreamliner',
  },
  {
    Client: 'EL AL Israel Airlines',
    'Flight name': 'CDG - TLV',
    'Origin Airport': 'Paris Charles de Gaulle',
    'Destination Airport': 'Ben Gurion Intl',
    'Origin city': 'Paris',
    'Destination City': 'Tel-aviv',
    'Origin country': 'France',
    'Destination country': 'Israel',
    'Flight ID': 'LY320',
    'Flight due date': '12/3/24',
    'Departure time': '11:15 am',
    'Arrival time': '4:40 pm',
    'Flight Duration': '4h 25m',
    'Arrival type': 'Noon',
    'Flight date finish': '12/3/24',
    'My Price': '236',
    'Last Scan': '15/04/2024',
    'Cabin baggage price': null,
    'Checked baggae price': '90$',
    Aircraft: 'Boeing 737-900',
  },
  {
    Client: 'EL AL Israel Airlines',
    'Flight name': 'MXP - TLV',
    'Origin Airport': 'Milan Malpensa',
    'Destination Airport': 'Ben Gurion Intl',
    'Origin city': 'Milan',
    'Destination City': 'Tel-aviv',
    'Origin country': 'Italy',
    'Destination country': 'Israel',
    'Flight ID': 'LY388',
    'Flight due date': '12/3/24',
    'Departure time': '10:05 pm',
    'Arrival time': '2:50 am',
    'Flight Duration': '3h 45m',
    'Arrival type': 'Night',
    'Flight date finish': '12/4/24',
    'My Price': '206',
    'Last Scan': '15/04/2024',
    'Cabin baggage price': null,
    'Checked baggae price': '90$',
    Aircraft: 'Boeing 737-900',
  },
  {
    Client: 'EL AL Israel Airlines',
    'Flight name': 'AMS - TLV',
    'Origin Airport': 'AMS Amsterdam',
    'Destination Airport': 'Ben Gurion Intl',
    'Origin city': 'Amsterdam',
    'Destination City': 'Tel-aviv',
    'Origin country': 'Netherlands',
    'Destination country': 'Israel',
    'Flight ID': 'LY338',
    'Flight due date': '12/4/24',
    'Departure time': '9:15 am',
    'Arrival time': '2:40 pm',
    'Flight Duration': '4h 25m',
    'Arrival type': 'Noon',
    'Flight date finish': '12/4/24',
    'My Price': '201',
    'Last Scan': '15/04/2024',
    'Cabin baggage price': null,
    'Checked baggae price': '90$',
    Aircraft: 'Boeing 737-900',
  },
  {
    Client: 'EL AL Israel Airlines',
    'Flight name': 'WAW - TLV',
    'Origin Airport': 'Warsaw Chopin',
    'Destination Airport': 'Ben Gurion Intl',
    'Origin city': 'Warsaw',
    'Destination City': 'Tel-aviv',
    'Origin country': 'Polland',
    'Destination country': 'Israel',
    'Flight ID': 'LY9252',
    'Flight due date': '12/6/24',
    'Departure time': '3:25 pm',
    'Arrival time': '8:10 pm',
    'Flight Duration': '3h 45m',
    'Arrival type': 'Evening',
    'Flight date finish': '12/6/24',
    'My Price': '222',
    'Last Scan': '15/04/2024',
    'Cabin baggage price': null,
    'Checked baggae price': '90$',
    Aircraft: 'Boeing 737-800',
  },
];
export const competitorsFlights: any[] = [
  {
    Competitor: 'British Airways',
    'Flight name': 'TLV - EWR',
    'Origin Airport': 'Ben Gurion Intl',
    'Destination Airport': 'Newark International Airport',
    'Origin city': 'Tel-aviv',
    'Destination City': 'New York',
    'Origin country': 'Israel',
    'Destination country': 'USA',
    'Flight ID': 'BA162',
    'Flight due date': '11/29/24',
    'Departure time': '6:20 am',
    'Arrival time': '9:45 am',
    'Flight Duration': '5h 25m',
    'Arrival type': 'Morning',
    'Flight date finish': '11/29/24',
    'My Price': '150',
    'Last Scan': '15/04/2020',
    'Cabin baggage price': null,
    'Checked baggae price': '90$',
    Aircraft: 'Boeing 777',
  },
  {
    Competitor: 'Wizz-Air',
    'Flight name': 'TLV - LHR',
    'Origin Airport': 'Ben Gurion Intl',
    'Destination Airport': 'Newark International Airport',
    'Origin city': 'Tel-aviv',
    'Destination City': 'New York',
    'Origin country': 'Israel',
    'Destination country': 'USA',
    'Flight ID': 'BA162',
    'Flight due date': '11/29/24',
    'Departure time': '6:20 am',
    'Arrival time': '9:45 am',
    'Flight Duration': '5h 25m',
    'Arrival type': 'Morning',
    'Flight date finish': '11/29/24',
    'My Price': '100',
    'Last Scan': '15/04/2020',
    'Cabin baggage price': null,
    'Checked baggae price': '90$',
    Aircraft: 'Boeing 777',
  },
  {
    Competitor: 'British Airways',
    'Flight name': 'TLV - EWR',
    'Origin Airport': 'Ben Gurion Intl',
    'Destination Airport': 'Newark International Airport',
    'Origin city': 'Tel-aviv',
    'Destination City': 'New York',
    'Origin country': 'Israel',
    'Destination country': 'USA',
    'Flight ID': 'BA162',
    'Flight due date': '11/29/24',
    'Departure time': '6:20 am',
    'Arrival time': '9:45 am',
    'Flight Duration': '5h 25m',
    'Arrival type': 'Morning',
    'Flight date finish': '11/29/24',
    'My Price': '190',
    'Last Scan': '15/04/2020',
    'Cabin baggage price': null,
    'Checked baggae price': '90$',
    Aircraft: 'Boeing 777',
  },
  {
    Competitor: 'British Airways',
    'Flight name': 'TLV - LHR',
    'Origin Airport': 'Ben Gurion Intl',
    'Destination Airport': 'London Heathrow',
    'Origin city': 'Tel-aviv',
    'Destination City': 'London',
    'Origin country': 'Israel',
    'Destination country': 'United kingdom',
    'Flight ID': 'BA162',
    'Flight due date': '11/29/24',
    'Departure time': '6:20 am',
    'Arrival time': '9:45 am',
    'Flight Duration': '5h 25m',
    'Arrival type': 'Morning',
    'Flight date finish': '11/29/24',
    'My Price': '199',
    'Last Scan': '15/04/2020',
    'Cabin baggage price': null,
    'Checked baggae price': '90$',
    Aircraft: 'Boeing 777',
  },
  {
    Competitor: 'British Airways',
    'Flight name': 'TLV - LHR',
    'Origin Airport': 'Ben Gurion Intl',
    'Destination Airport': 'London Heathrow',
    'Origin city': 'Tel-aviv',
    'Destination City': 'London',
    'Origin country': 'Israel',
    'Destination country': 'United kingdom',
    'Flight ID': 'BA164',
    'Flight due date': '11/29/24',
    'Departure time': '4:40 pm',
    'Arrival time': '8:00 pm',
    'Flight Duration': '5h 20m',
    'Arrival type': 'Evening',
    'Flight date finish': '11/29/24',
    'My Price': '220',
    'Last Scan': '15/04/2020',
    'Cabin baggage price': null,
    'Checked baggae price': '90$',
    Aircraft: 'Boeing 777',
  },
  {
    Competitor: 'British Airways',
    'Flight name': 'TLV - LHR',
    'Origin Airport': 'Ben Gurion Intl',
    'Destination Airport': 'London Heathrow',
    'Origin city': 'Tel-aviv',
    'Destination City': 'London',
    'Origin country': 'Israel',
    'Destination country': 'United kingdom',
    'Flight ID': 'BA162',
    'Flight due date': '11/30/24',
    'Departure time': '6:20 am',
    'Arrival time': '9:45 am',
    'Flight Duration': '5h 25m',
    'Arrival type': 'Morning',
    'Flight date finish': '11/30/24',
    'My Price': '199',
    'Last Scan': '15/04/2020',
    'Cabin baggage price': null,
    'Checked baggae price': '90$',
    Aircraft: 'Boeing 777',
  },
  {
    Competitor: 'British Airways',
    'Flight name': 'TLV - LHR',
    'Origin Airport': 'Ben Gurion Intl',
    'Destination Airport': 'London Heathrow',
    'Origin city': 'Tel-aviv',
    'Destination City': 'London',
    'Origin country': 'Israel',
    'Destination country': 'United kingdom',
    'Flight ID': 'BA164',
    'Flight due date': '11/30/24',
    'Departure time': '4:40 pm',
    'Arrival time': '8:00 pm',
    'Flight Duration': '5h 20m',
    'Arrival type': 'Evening',
    'Flight date finish': '11/30/24',
    'My Price': '199',
    'Last Scan': '15/04/2020',
    'Cabin baggage price': null,
    'Checked baggae price': '90$',
    Aircraft: 'Boeing 777',
  },
  {
    Competitor: 'British Airways',
    'Flight name': 'TLV - LHR',
    'Origin Airport': 'Ben Gurion Intl',
    'Destination Airport': 'London Heathrow',
    'Origin city': 'Tel-aviv',
    'Destination City': 'London',
    'Origin country': 'Israel',
    'Destination country': 'United kingdom',
    'Flight ID': 'BA162',
    'Flight due date': '12/1/24',
    'Departure time': '6:20 am',
    'Arrival time': '9:45 am',
    'Flight Duration': '5h 25m',
    'Arrival type': 'Morning',
    'Flight date finish': '12/1/24',
    'My Price': '199',
    'Last Scan': '15/04/2020',
    'Cabin baggage price': null,
    'Checked baggae price': '90$',
    Aircraft: 'Boeing 777',
  },
  {
    Competitor: 'British Airways',
    'Flight name': 'TLV - LHR',
    'Origin Airport': 'Ben Gurion Intl',
    'Destination Airport': 'London Heathrow',
    'Origin city': 'Tel-aviv',
    'Destination City': 'London',
    'Origin country': 'Israel',
    'Destination country': 'United kingdom',
    'Flight ID': 'BA164',
    'Flight due date': '12/1/24',
    'Departure time': '4:40 pm',
    'Arrival time': '8:00 pm',
    'Flight Duration': '5h 20m',
    'Arrival type': 'Evening',
    'Flight date finish': '12/1/24',
    'My Price': '220',
    'Last Scan': '15/04/2020',
    'Cabin baggage price': null,
    'Checked baggae price': '90$',
    Aircraft: 'Boeing 777',
  },
  {
    Competitor: 'British Airways',
    'Flight name': 'TLV - LHR',
    'Origin Airport': 'Ben Gurion Intl',
    'Destination Airport': 'London Heathrow',
    'Origin city': 'Tel-aviv',
    'Destination City': 'London',
    'Origin country': 'Israel',
    'Destination country': 'United kingdom',
    'Flight ID': 'BA162',
    'Flight due date': '12/2/24',
    'Departure time': '6:20 am',
    'Arrival time': '9:45 am',
    'Flight Duration': '5h 25m',
    'Arrival type': 'Morning',
    'Flight date finish': '12/2/24',
    'My Price': '199',
    'Last Scan': '15/04/2020',
    'Cabin baggage price': null,
    'Checked baggae price': '90$',
    Aircraft: 'Boeing 777',
  },
  {
    Competitor: 'British Airways',
    'Flight name': 'TLV - LHR',
    'Origin Airport': 'Ben Gurion Intl',
    'Destination Airport': 'London Heathrow',
    'Origin city': 'Tel-aviv',
    'Destination City': 'London',
    'Origin country': 'Israel',
    'Destination country': 'United kingdom',
    'Flight ID': 'BA164',
    'Flight due date': '12/2/24',
    'Departure time': '4:40 pm',
    'Arrival time': '8:00 pm',
    'Flight Duration': '5h 20m',
    'Arrival type': 'Evening',
    'Flight date finish': '12/2/24',
    'My Price': '220',
    'Last Scan': '15/04/2020',
    'Cabin baggage price': null,
    'Checked baggae price': '90$',
    Aircraft: 'Boeing 777',
  },
  {
    Competitor: 'British Airways',
    'Flight name': 'TLV - LHR',
    'Origin Airport': 'Ben Gurion Intl',
    'Destination Airport': 'London Heathrow',
    'Origin city': 'Tel-aviv',
    'Destination City': 'London',
    'Origin country': 'Israel',
    'Destination country': 'United kingdom',
    'Flight ID': 'BA162',
    'Flight due date': '12/3/24',
    'Departure time': '6:20 am',
    'Arrival time': '9:45 am',
    'Flight Duration': '5h 25m',
    'Arrival type': 'Morning',
    'Flight date finish': '12/3/24',
    'My Price': '220',
    'Last Scan': '15/04/2020',
    'Cabin baggage price': null,
    'Checked baggae price': '90$',
    Aircraft: 'Boeing 777',
  },
  {
    Competitor: 'British Airways',
    'Flight name': 'TLV - LHR',
    'Origin Airport': 'Ben Gurion Intl',
    'Destination Airport': 'London Heathrow',
    'Origin city': 'Tel-aviv',
    'Destination City': 'London',
    'Origin country': 'Israel',
    'Destination country': 'United kingdom',
    'Flight ID': 'BA164',
    'Flight due date': '12/3/24',
    'Departure time': '4:40 pm',
    'Arrival time': '8:00 pm',
    'Flight Duration': '5h 20m',
    'Arrival type': 'Evening',
    'Flight date finish': '12/3/24',
    'My Price': '248',
    'Last Scan': '15/04/2020',
    'Cabin baggage price': null,
    'Checked baggae price': '90$',
    Aircraft: 'Boeing 777',
  },
  {
    Competitor: 'British Airways',
    'Flight name': 'TLV - LHR',
    'Origin Airport': 'Ben Gurion Intl',
    'Destination Airport': 'London Heathrow',
    'Origin city': 'Tel-aviv',
    'Destination City': 'London',
    'Origin country': 'Israel',
    'Destination country': 'United kingdom',
    'Flight ID': 'BA162',
    'Flight due date': '12/4/24',
    'Departure time': '6:20 am',
    'Arrival time': '9:45 am',
    'Flight Duration': '5h 25m',
    'Arrival type': 'Morning',
    'Flight date finish': '12/4/24',
    'My Price': '199',
    'Last Scan': '15/04/2020',
    'Cabin baggage price': null,
    'Checked baggae price': '90$',
    Aircraft: 'Boeing 777',
  },
  {
    Competitor: 'British Airways',
    'Flight name': 'LHR - TLV',
    'Origin Airport': 'London Heathrow',
    'Destination Airport': 'Ben Gurion Intl',
    'Origin city': 'London',
    'Destination City': 'Tel-aviv',
    'Origin country': 'United kingdom',
    'Destination country': 'Israel',
    'Flight ID': 'BA163',
    'Flight due date': '11/30/24',
    'Departure time': '9:10 pm',
    'Arrival time': '3:55 am',
    'Flight Duration': '4h 45m',
    'Arrival type': 'Night',
    'Flight date finish': '12/1/24',
    'My Price': '271',
    'Last Scan': '15/04/2020',
    'Cabin baggage price': null,
    'Checked baggae price': '90$',
    Aircraft: 'Boeing 777',
  },
  {
    Competitor: 'EasyJet',
    'Flight name': 'TLV - MXP',
    'Origin Airport': 'Ben Gurion Intl',
    'Destination Airport': 'Milan Malpensa',
    'Origin city': 'Tel-aviv',
    'Destination City': 'Milan',
    'Origin country': 'Israel',
    'Destination country': 'Italy',
    'Flight ID': 'EZY2564',
    'Flight due date': '11/29/24',
    'Departure time': '12:55 pm',
    'Arrival time': '4:15 pm',
    'Flight Duration': '4h 20m',
    'Arrival type': 'Noon',
    'Flight date finish': '11/29/24',
    'My Price': '180',
    'Last Scan': '15/04/2020',
    'Cabin baggage price': '25$',
    'Checked baggae price': '90$',
    Aircraft: 'Airbus A321-100/200',
  },
  {
    Competitor: 'EasyJet',
    'Flight name': 'TLV - MXP',
    'Origin Airport': 'Ben Gurion Intl',
    'Destination Airport': 'Milan Malpensa',
    'Origin city': 'Tel-aviv',
    'Destination City': 'Milan',
    'Origin country': 'Israel',
    'Destination country': 'Italy',
    'Flight ID': 'EZY2566',
    'Flight due date': '11/30/24',
    'Departure time': '8:40 pm',
    'Arrival time': '11:55 pm',
    'Flight Duration': '4h 15m',
    'Arrival type': 'Evening',
    'Flight date finish': '11/30/24',
    'My Price': '144',
    'Last Scan': '15/04/2020',
    'Cabin baggage price': '25$',
    'Checked baggae price': '90$',
    Aircraft: 'Airbus A321-100/200',
  },
  {
    Competitor: 'EasyJet',
    'Flight name': 'TLV - CDG',
    'Origin Airport': 'Ben Gurion Intl',
    'Destination Airport': 'Paris Charles de Gaulle',
    'Origin city': 'Tel-aviv',
    'Destination City': 'Paris',
    'Origin country': 'Israel',
    'Destination country': 'France',
    'Flight ID': 'EZY3738',
    'Flight due date': '11/30/24',
    'Departure time': '7:15 pm',
    'Arrival time': '11:35 pm',
    'Flight Duration': '5h 20m',
    'Arrival type': 'Evening',
    'Flight date finish': '11/30/24',
    'My Price': '270',
    'Last Scan': '15/04/2020',
    'Cabin baggage price': '25$',
    'Checked baggae price': '90$',
    Aircraft: 'Airbus A321-100/200',
  },
  {
    Competitor: 'EasyJet',
    'Flight name': 'TLV - CDG',
    'Origin Airport': 'Ben Gurion Intl',
    'Destination Airport': 'Paris Charles de Gaulle',
    'Origin city': 'Tel-aviv',
    'Destination City': 'Paris',
    'Origin country': 'Israel',
    'Destination country': 'France',
    'Flight ID': 'EZY3738',
    'Flight due date': '12/1/24',
    'Departure time': '2:00 pm',
    'Arrival time': '6:20 pm',
    'Flight Duration': '5h 20m',
    'Arrival type': 'Evening',
    'Flight date finish': '12/1/24',
    'My Price': '246.55',
    'Last Scan': '15/04/2020',
    'Cabin baggage price': '25$',
    'Checked baggae price': '90$',
    Aircraft: 'Airbus A321-100/200',
  },
  {
    Competitor: 'EasyJet',
    'Flight name': 'TLV - AMS',
    'Origin Airport': 'Ben Gurion Intl',
    'Destination Airport': 'AMS Amsterdam',
    'Origin city': 'Tel-aviv',
    'Destination City': 'Amsterdam',
    'Origin country': 'Israel',
    'Destination country': 'Netherlands',
    'Flight ID': 'EZY7934',
    'Flight due date': '11/30/24',
    'Departure time': '2:00 pm',
    'Arrival time': '6:10 pm',
    'Flight Duration': '5h 10m',
    'Arrival type': 'Evening',
    'Flight date finish': '11/30/24',
    'My Price': '189',
    'Last Scan': '15/04/2020',
    'Cabin baggage price': '25$',
    'Checked baggae price': '90$',
    Aircraft: 'Airbus A320-100/200',
  },
  {
    Competitor: 'EasyJet',
    'Flight name': 'TLV - AMS',
    'Origin Airport': 'Ben Gurion Intl',
    'Destination Airport': 'AMS Amsterdam',
    'Origin city': 'Tel-aviv',
    'Destination City': 'Amsterdam',
    'Origin country': 'Israel',
    'Destination country': 'Netherlands',
    'Flight ID': 'EZY7934',
    'Flight due date': '12/7/24',
    'Departure time': '2:00 pm',
    'Arrival time': '6:10 pm',
    'Flight Duration': '5h 10m',
    'Arrival type': 'Evening',
    'Flight date finish': '12/7/24',
    'My Price': '208',
    'Last Scan': '15/04/2020',
    'Cabin baggage price': '25$',
    'Checked baggae price': '90$',
    Aircraft: 'Airbus A320-100/200',
  },
  {
    Competitor: 'Wizz-Air',
    'Flight name': 'TLV - WAW',
    'Origin Airport': 'Ben Gurion Intl',
    'Destination Airport': 'Warsaw Chopin',
    'Origin city': 'Tel-aviv',
    'Destination City': 'Warsaw',
    'Origin country': 'Israel',
    'Destination country': 'Polland',
    'Flight ID': 'W61560',
    'Flight due date': '11/29/24',
    'Departure time': '7:50 pm',
    'Arrival time': '10:50 pm',
    'Flight Duration': '4h',
    'Arrival type': 'Evening',
    'Flight date finish': '11/29/24',
    'My Price': '78',
    'Last Scan': '15/04/2020',
    'Cabin baggage price': '25$',
    'Checked baggae price': '90$',
    Aircraft: 'Airbus A321neo',
  },
  {
    Competitor: 'Wizz-Air',
    'Flight name': 'TLV - WAW',
    'Origin Airport': 'Ben Gurion Intl',
    'Destination Airport': 'Warsaw Chopin',
    'Origin city': 'Tel-aviv',
    'Destination City': 'Warsaw',
    'Origin country': 'Israel',
    'Destination country': 'Polland',
    'Flight ID': 'W61560',
    'Flight due date': '12/3/24',
    'Departure time': '7:50 pm',
    'Arrival time': '10:50 pm',
    'Flight Duration': '4h',
    'Arrival type': 'Evening',
    'Flight date finish': '12/3/24',
    'My Price': '78',
    'Last Scan': '15/04/2020',
    'Cabin baggage price': '25$',
    'Checked baggae price': '90$',
    Aircraft: 'Airbus A321neo',
  },
  {
    Competitor: 'Wizz-Air',
    'Flight name': 'TLV - BUD',
    'Origin Airport': 'Ben Gurion Intl',
    'Destination Airport': 'BUD Budapest',
    'Origin city': 'Tel-aviv',
    'Destination City': 'Budapest',
    'Origin country': 'Israel',
    'Destination country': 'Hungary',
    'Flight ID': 'W62326',
    'Flight due date': '11/29/24',
    'Departure time': '11:10 am',
    'Arrival time': '1:35 pm',
    'Flight Duration': '3h 25m',
    'Arrival type': 'Noon',
    'Flight date finish': '11/29/24',
    'My Price': '78',
    'Last Scan': '15/04/2020',
    'Cabin baggage price': '25$',
    'Checked baggae price': '90$',
    Aircraft: 'Airbus A321neo',
  },
  {
    Competitor: 'Wizz-Air',
    'Flight name': 'TLV - BUD',
    'Origin Airport': 'Ben Gurion Intl',
    'Destination Airport': 'BUD Budapest',
    'Origin city': 'Tel-aviv',
    'Destination City': 'Budapest',
    'Origin country': 'Israel',
    'Destination country': 'Hungary',
    'Flight ID': 'W62328',
    'Flight due date': '11/29/24',
    'Departure time': '9:40 pm',
    'Arrival time': '11:55 pm',
    'Flight Duration': '3h 15m',
    'Arrival type': 'Evening',
    'Flight date finish': '11/29/24',
    'My Price': '67',
    'Last Scan': '15/04/2020',
    'Cabin baggage price': '25$',
    'Checked baggae price': '90$',
    Aircraft: 'Airbus A320-100/200',
  },
  {
    Competitor: 'Wizz-Air',
    'Flight name': 'TLV - BUD',
    'Origin Airport': 'Ben Gurion Intl',
    'Destination Airport': 'BUD Budapest',
    'Origin city': 'Tel-aviv',
    'Destination City': 'Budapest',
    'Origin country': 'Israel',
    'Destination country': 'Hungary',
    'Flight ID': 'W62330',
    'Flight due date': '12/3/24',
    'Departure time': '4:35 pm',
    'Arrival time': '7:00 pm',
    'Flight Duration': '3h 25m',
    'Arrival type': 'Evening',
    'Flight date finish': '12/3/24',
    'My Price': '67',
    'Last Scan': '15/04/2020',
    'Cabin baggage price': '25$',
    'Checked baggae price': '90$',
    Aircraft: 'Airbus A320-100/200',
  },
  {
    Competitor: 'Wizz-Air',
    'Flight name': 'BUD - TLV',
    'Origin Airport': 'BUD Budapest',
    'Destination Airport': 'Ben Gurion Intl',
    'Origin city': 'Budapest',
    'Destination City': 'Tel-aviv',
    'Origin country': 'Hungary',
    'Destination country': 'Israel',
    'Flight ID': 'W62325',
    'Flight due date': '11/29/24',
    'Departure time': '6:00 am',
    'Arrival time': '10:15 am',
    'Flight Duration': '3h 15m',
    'Arrival type': 'Morning',
    'Flight date finish': '11/29/24',
    'My Price': '67',
    'Last Scan': '15/04/2020',
    'Cabin baggage price': '25$',
    'Checked baggae price': '90$',
    Aircraft: 'Airbus A321neo',
  },
  {
    Competitor: 'Wizz-Air',
    'Flight name': 'LTN - TLV',
    'Origin Airport': 'London Luton',
    'Destination Airport': 'Ben Gurion Intl',
    'Origin city': 'London',
    'Destination City': 'Tel-aviv',
    'Origin country': 'United kingdom',
    'Destination country': 'Israel',
    'Flight ID': 'W94451',
    'Flight due date': '11/30/24',
    'Departure time': '1:45 pm',
    'Arrival time': '8:55 pm',
    'Flight Duration': '5h 10m',
    'Arrival type': 'Evening',
    'Flight date finish': '11/30/24',
    'My Price': '142',
    'Last Scan': '15/04/2020',
    'Cabin baggage price': '25$',
    'Checked baggae price': '90$',
    Aircraft: 'Airbus A320-100/200',
  },
  {
    Competitor: 'EasyJet',
    'Flight name': 'LTN - TLV',
    'Origin Airport': 'London Luton',
    'Destination Airport': 'Ben Gurion Intl',
    'Origin city': 'London',
    'Destination City': 'Tel-aviv',
    'Origin country': 'United kingdom',
    'Destination country': 'Israel',
    'Flight ID': 'EZY2085',
    'Flight due date': '11/30/24',
    'Departure time': '11:40 am',
    'Arrival time': '6:40 pm',
    'Flight Duration': '5h',
    'Arrival type': 'Evening',
    'Flight date finish': '11/30/24',
    'My Price': '142.18',
    'Last Scan': '15/04/2020',
    'Cabin baggage price': '25$',
    'Checked baggae price': '90$',
    Aircraft: 'Airbus A320-100/200',
  },
  {
    Competitor: 'EasyJet',
    'Flight name': 'CDG - TLV',
    'Origin Airport': 'Paris Charles de Gaulle',
    'Destination Airport': 'Ben Gurion Intl',
    'Origin city': 'Paris',
    'Destination City': 'Tel-aviv',
    'Origin country': 'France',
    'Destination country': 'Israel',
    'Flight ID': 'EZY3737',
    'Flight due date': '12/3/24',
    'Departure time': '12:40 pm',
    'Arrival time': '6:15 pm',
    'Flight Duration': '4h 35m',
    'Arrival type': 'Evening',
    'Flight date finish': '12/3/24',
    'My Price': '183.29',
    'Last Scan': '15/04/2020',
    'Cabin baggage price': '25$',
    'Checked baggae price': '90$',
    Aircraft: 'Airbus A321-100/200',
  },
  {
    Competitor: 'EasyJet',
    'Flight name': 'AMS - TLV',
    'Origin Airport': 'AMS Amsterdam',
    'Destination Airport': 'Ben Gurion Intl',
    'Origin city': 'Amsterdam',
    'Destination City': 'Tel-aviv',
    'Origin country': 'Netherlands',
    'Destination country': 'Israel',
    'Flight ID': 'EZY7933',
    'Flight due date': '12/4/24',
    'Departure time': '7:15 am',
    'Arrival time': '1:00 pm',
    'Flight Duration': '4h 45m',
    'Arrival type': 'Noon',
    'Flight date finish': '12/4/24',
    'My Price': '168',
    'Last Scan': '15/04/2020',
    'Cabin baggage price': '25$',
    'Checked baggae price': '90$',
    Aircraft: 'Airbus A320-100/200',
  },
  {
    Competitor: 'Wizz-Air',
    'Flight name': 'WAW - TLV',
    'Origin Airport': 'Warsaw Chopin',
    'Destination Airport': 'Ben Gurion Intl',
    'Origin city': 'Warsaw',
    'Destination City': 'Tel-aviv',
    'Origin country': 'Polland',
    'Destination country': 'Israel',
    'Flight ID': 'W61559',
    'Flight due date': '12/6/24',
    'Departure time': '2:05 pm',
    'Arrival time': '6:55 pm',
    'Flight Duration': '3h 50m',
    'Arrival type': 'Evening',
    'Flight date finish': '12/6/24',
    'My Price': '63',
    'Last Scan': '15/04/2020',
    'Cabin baggage price': '25$',
    'Checked baggae price': '90$',
    Aircraft: 'Airbus A321neo',
  },
  {
    Competitor: 'British Airways',
    'Flight name': 'TLV - EWR',
    'Origin Airport': 'Ben Gurion Intl',
    'Destination Airport': 'Newark International Airport',
    'Origin city': 'Tel-aviv',
    'Destination City': 'New York',
    'Origin country': 'Israel',
    'Destination country': 'USA',
    'Flight ID': 'BA162',
    'Flight due date': '11/29/24',
    'Departure time': '6:20 am',
    'Arrival time': '9:45 am',
    'Flight Duration': '5h 25m',
    'Arrival type': 'Morning',
    'Flight date finish': '11/29/24',
    'My Price': '150',
    'Last Scan': '15/04/2020',
    'Cabin baggage price': null,
    'Checked baggae price': '90$',
    Aircraft: 'Boeing 777',
  },
  {
    Competitor: 'Wizz-Air',
    'Flight name': 'TLV - LHR',
    'Origin Airport': 'Ben Gurion Intl',
    'Destination Airport': 'Newark International Airport',
    'Origin city': 'Tel-aviv',
    'Destination City': 'New York',
    'Origin country': 'Israel',
    'Destination country': 'USA',
    'Flight ID': 'BA162',
    'Flight due date': '11/29/24',
    'Departure time': '6:20 am',
    'Arrival time': '9:45 am',
    'Flight Duration': '5h 25m',
    'Arrival type': 'Morning',
    'Flight date finish': '11/29/24',
    'My Price': '100',
    'Last Scan': '15/04/2020',
    'Cabin baggage price': null,
    'Checked baggae price': '90$',
    Aircraft: 'Boeing 777',
  },
  {
    Competitor: 'British Airways',
    'Flight name': 'TLV - EWR',
    'Origin Airport': 'Ben Gurion Intl',
    'Destination Airport': 'Newark International Airport',
    'Origin city': 'Tel-aviv',
    'Destination City': 'New York',
    'Origin country': 'Israel',
    'Destination country': 'USA',
    'Flight ID': 'BA162',
    'Flight due date': '11/29/24',
    'Departure time': '6:20 am',
    'Arrival time': '9:45 am',
    'Flight Duration': '5h 25m',
    'Arrival type': 'Morning',
    'Flight date finish': '11/29/24',
    'My Price': '190',
    'Last Scan': '15/04/2020',
    'Cabin baggage price': null,
    'Checked baggae price': '90$',
    Aircraft: 'Boeing 777',
  },
  {
    Competitor: 'British Airways',
    'Flight name': 'TLV - LHR',
    'Origin Airport': 'Ben Gurion Intl',
    'Destination Airport': 'London Heathrow',
    'Origin city': 'Tel-aviv',
    'Destination City': 'London',
    'Origin country': 'Israel',
    'Destination country': 'United kingdom',
    'Flight ID': 'BA162',
    'Flight due date': '11/29/24',
    'Departure time': '6:20 am',
    'Arrival time': '9:45 am',
    'Flight Duration': '5h 25m',
    'Arrival type': 'Morning',
    'Flight date finish': '11/29/24',
    'My Price': '199',
    'Last Scan': '15/04/2020',
    'Cabin baggage price': null,
    'Checked baggae price': '90$',
    Aircraft: 'Boeing 777',
  },
  {
    Competitor: 'British Airways',
    'Flight name': 'TLV - LHR',
    'Origin Airport': 'Ben Gurion Intl',
    'Destination Airport': 'London Heathrow',
    'Origin city': 'Tel-aviv',
    'Destination City': 'London',
    'Origin country': 'Israel',
    'Destination country': 'United kingdom',
    'Flight ID': 'BA164',
    'Flight due date': '11/29/24',
    'Departure time': '4:40 pm',
    'Arrival time': '8:00 pm',
    'Flight Duration': '5h 20m',
    'Arrival type': 'Evening',
    'Flight date finish': '11/29/24',
    'My Price': '220',
    'Last Scan': '15/04/2020',
    'Cabin baggage price': null,
    'Checked baggae price': '90$',
    Aircraft: 'Boeing 777',
  },
  {
    Competitor: 'British Airways',
    'Flight name': 'TLV - LHR',
    'Origin Airport': 'Ben Gurion Intl',
    'Destination Airport': 'London Heathrow',
    'Origin city': 'Tel-aviv',
    'Destination City': 'London',
    'Origin country': 'Israel',
    'Destination country': 'United kingdom',
    'Flight ID': 'BA162',
    'Flight due date': '11/30/24',
    'Departure time': '6:20 am',
    'Arrival time': '9:45 am',
    'Flight Duration': '5h 25m',
    'Arrival type': 'Morning',
    'Flight date finish': '11/30/24',
    'My Price': '199',
    'Last Scan': '15/04/2020',
    'Cabin baggage price': null,
    'Checked baggae price': '90$',
    Aircraft: 'Boeing 777',
  },
  {
    Competitor: 'British Airways',
    'Flight name': 'TLV - LHR',
    'Origin Airport': 'Ben Gurion Intl',
    'Destination Airport': 'London Heathrow',
    'Origin city': 'Tel-aviv',
    'Destination City': 'London',
    'Origin country': 'Israel',
    'Destination country': 'United kingdom',
    'Flight ID': 'BA164',
    'Flight due date': '11/30/24',
    'Departure time': '4:40 pm',
    'Arrival time': '8:00 pm',
    'Flight Duration': '5h 20m',
    'Arrival type': 'Evening',
    'Flight date finish': '11/30/24',
    'My Price': '199',
    'Last Scan': '15/04/2020',
    'Cabin baggage price': null,
    'Checked baggae price': '90$',
    Aircraft: 'Boeing 777',
  },
  {
    Competitor: 'British Airways',
    'Flight name': 'TLV - LHR',
    'Origin Airport': 'Ben Gurion Intl',
    'Destination Airport': 'London Heathrow',
    'Origin city': 'Tel-aviv',
    'Destination City': 'London',
    'Origin country': 'Israel',
    'Destination country': 'United kingdom',
    'Flight ID': 'BA162',
    'Flight due date': '12/1/24',
    'Departure time': '6:20 am',
    'Arrival time': '9:45 am',
    'Flight Duration': '5h 25m',
    'Arrival type': 'Morning',
    'Flight date finish': '12/1/24',
    'My Price': '199',
    'Last Scan': '15/04/2020',
    'Cabin baggage price': null,
    'Checked baggae price': '90$',
    Aircraft: 'Boeing 777',
  },
  {
    Competitor: 'British Airways',
    'Flight name': 'TLV - LHR',
    'Origin Airport': 'Ben Gurion Intl',
    'Destination Airport': 'London Heathrow',
    'Origin city': 'Tel-aviv',
    'Destination City': 'London',
    'Origin country': 'Israel',
    'Destination country': 'United kingdom',
    'Flight ID': 'BA164',
    'Flight due date': '12/1/24',
    'Departure time': '4:40 pm',
    'Arrival time': '8:00 pm',
    'Flight Duration': '5h 20m',
    'Arrival type': 'Evening',
    'Flight date finish': '12/1/24',
    'My Price': '220',
    'Last Scan': '15/04/2020',
    'Cabin baggage price': null,
    'Checked baggae price': '90$',
    Aircraft: 'Boeing 777',
  },
  {
    Competitor: 'British Airways',
    'Flight name': 'TLV - LHR',
    'Origin Airport': 'Ben Gurion Intl',
    'Destination Airport': 'London Heathrow',
    'Origin city': 'Tel-aviv',
    'Destination City': 'London',
    'Origin country': 'Israel',
    'Destination country': 'United kingdom',
    'Flight ID': 'BA162',
    'Flight due date': '12/2/24',
    'Departure time': '6:20 am',
    'Arrival time': '9:45 am',
    'Flight Duration': '5h 25m',
    'Arrival type': 'Morning',
    'Flight date finish': '12/2/24',
    'My Price': '199',
    'Last Scan': '15/04/2020',
    'Cabin baggage price': null,
    'Checked baggae price': '90$',
    Aircraft: 'Boeing 777',
  },
  {
    Competitor: 'British Airways',
    'Flight name': 'TLV - LHR',
    'Origin Airport': 'Ben Gurion Intl',
    'Destination Airport': 'London Heathrow',
    'Origin city': 'Tel-aviv',
    'Destination City': 'London',
    'Origin country': 'Israel',
    'Destination country': 'United kingdom',
    'Flight ID': 'BA164',
    'Flight due date': '12/2/24',
    'Departure time': '4:40 pm',
    'Arrival time': '8:00 pm',
    'Flight Duration': '5h 20m',
    'Arrival type': 'Evening',
    'Flight date finish': '12/2/24',
    'My Price': '220',
    'Last Scan': '15/04/2020',
    'Cabin baggage price': null,
    'Checked baggae price': '90$',
    Aircraft: 'Boeing 777',
  },
  {
    Competitor: 'British Airways',
    'Flight name': 'TLV - LHR',
    'Origin Airport': 'Ben Gurion Intl',
    'Destination Airport': 'London Heathrow',
    'Origin city': 'Tel-aviv',
    'Destination City': 'London',
    'Origin country': 'Israel',
    'Destination country': 'United kingdom',
    'Flight ID': 'BA162',
    'Flight due date': '12/3/24',
    'Departure time': '6:20 am',
    'Arrival time': '9:45 am',
    'Flight Duration': '5h 25m',
    'Arrival type': 'Morning',
    'Flight date finish': '12/3/24',
    'My Price': '220',
    'Last Scan': '15/04/2020',
    'Cabin baggage price': null,
    'Checked baggae price': '90$',
    Aircraft: 'Boeing 777',
  },
  {
    Competitor: 'British Airways',
    'Flight name': 'TLV - LHR',
    'Origin Airport': 'Ben Gurion Intl',
    'Destination Airport': 'London Heathrow',
    'Origin city': 'Tel-aviv',
    'Destination City': 'London',
    'Origin country': 'Israel',
    'Destination country': 'United kingdom',
    'Flight ID': 'BA164',
    'Flight due date': '12/3/24',
    'Departure time': '4:40 pm',
    'Arrival time': '8:00 pm',
    'Flight Duration': '5h 20m',
    'Arrival type': 'Evening',
    'Flight date finish': '12/3/24',
    'My Price': '248',
    'Last Scan': '15/04/2020',
    'Cabin baggage price': null,
    'Checked baggae price': '90$',
    Aircraft: 'Boeing 777',
  },
  {
    Competitor: 'British Airways',
    'Flight name': 'TLV - LHR',
    'Origin Airport': 'Ben Gurion Intl',
    'Destination Airport': 'London Heathrow',
    'Origin city': 'Tel-aviv',
    'Destination City': 'London',
    'Origin country': 'Israel',
    'Destination country': 'United kingdom',
    'Flight ID': 'BA162',
    'Flight due date': '12/4/24',
    'Departure time': '6:20 am',
    'Arrival time': '9:45 am',
    'Flight Duration': '5h 25m',
    'Arrival type': 'Morning',
    'Flight date finish': '12/4/24',
    'My Price': '199',
    'Last Scan': '15/04/2020',
    'Cabin baggage price': null,
    'Checked baggae price': '90$',
    Aircraft: 'Boeing 777',
  },
  {
    Competitor: 'British Airways',
    'Flight name': 'LHR - TLV',
    'Origin Airport': 'London Heathrow',
    'Destination Airport': 'Ben Gurion Intl',
    'Origin city': 'London',
    'Destination City': 'Tel-aviv',
    'Origin country': 'United kingdom',
    'Destination country': 'Israel',
    'Flight ID': 'BA163',
    'Flight due date': '11/30/24',
    'Departure time': '9:10 pm',
    'Arrival time': '3:55 am',
    'Flight Duration': '4h 45m',
    'Arrival type': 'Night',
    'Flight date finish': '12/1/24',
    'My Price': '271',
    'Last Scan': '15/04/2020',
    'Cabin baggage price': null,
    'Checked baggae price': '90$',
    Aircraft: 'Boeing 777',
  },
  {
    Competitor: 'EasyJet',
    'Flight name': 'TLV - MXP',
    'Origin Airport': 'Ben Gurion Intl',
    'Destination Airport': 'Milan Malpensa',
    'Origin city': 'Tel-aviv',
    'Destination City': 'Milan',
    'Origin country': 'Israel',
    'Destination country': 'Italy',
    'Flight ID': 'EZY2564',
    'Flight due date': '11/29/24',
    'Departure time': '12:55 pm',
    'Arrival time': '4:15 pm',
    'Flight Duration': '4h 20m',
    'Arrival type': 'Noon',
    'Flight date finish': '11/29/24',
    'My Price': '180',
    'Last Scan': '15/04/2020',
    'Cabin baggage price': '25$',
    'Checked baggae price': '90$',
    Aircraft: 'Airbus A321-100/200',
  },
  {
    Competitor: 'EasyJet',
    'Flight name': 'TLV - MXP',
    'Origin Airport': 'Ben Gurion Intl',
    'Destination Airport': 'Milan Malpensa',
    'Origin city': 'Tel-aviv',
    'Destination City': 'Milan',
    'Origin country': 'Israel',
    'Destination country': 'Italy',
    'Flight ID': 'EZY2566',
    'Flight due date': '11/30/24',
    'Departure time': '8:40 pm',
    'Arrival time': '11:55 pm',
    'Flight Duration': '4h 15m',
    'Arrival type': 'Evening',
    'Flight date finish': '11/30/24',
    'My Price': '144',
    'Last Scan': '15/04/2020',
    'Cabin baggage price': '25$',
    'Checked baggae price': '90$',
    Aircraft: 'Airbus A321-100/200',
  },
  {
    Competitor: 'EasyJet',
    'Flight name': 'TLV - CDG',
    'Origin Airport': 'Ben Gurion Intl',
    'Destination Airport': 'Paris Charles de Gaulle',
    'Origin city': 'Tel-aviv',
    'Destination City': 'Paris',
    'Origin country': 'Israel',
    'Destination country': 'France',
    'Flight ID': 'EZY3738',
    'Flight due date': '11/30/24',
    'Departure time': '7:15 pm',
    'Arrival time': '11:35 pm',
    'Flight Duration': '5h 20m',
    'Arrival type': 'Evening',
    'Flight date finish': '11/30/24',
    'My Price': '168.96',
    'Last Scan': '15/04/2020',
    'Cabin baggage price': '25$',
    'Checked baggae price': '90$',
    Aircraft: 'Airbus A321-100/200',
  },
  {
    Competitor: 'EasyJet',
    'Flight name': 'TLV - CDG',
    'Origin Airport': 'Ben Gurion Intl',
    'Destination Airport': 'Paris Charles de Gaulle',
    'Origin city': 'Tel-aviv',
    'Destination City': 'Paris',
    'Origin country': 'Israel',
    'Destination country': 'France',
    'Flight ID': 'EZY3738',
    'Flight due date': '12/1/24',
    'Departure time': '2:00 pm',
    'Arrival time': '6:20 pm',
    'Flight Duration': '5h 20m',
    'Arrival type': 'Evening',
    'Flight date finish': '12/1/24',
    'My Price': '146.55',
    'Last Scan': '15/04/2020',
    'Cabin baggage price': '25$',
    'Checked baggae price': '90$',
    Aircraft: 'Airbus A321-100/200',
  },
  {
    Competitor: 'EasyJet',
    'Flight name': 'TLV - AMS',
    'Origin Airport': 'Ben Gurion Intl',
    'Destination Airport': 'AMS Amsterdam',
    'Origin city': 'Tel-aviv',
    'Destination City': 'Amsterdam',
    'Origin country': 'Israel',
    'Destination country': 'Netherlands',
    'Flight ID': 'EZY7934',
    'Flight due date': '11/30/24',
    'Departure time': '2:00 pm',
    'Arrival time': '6:10 pm',
    'Flight Duration': '5h 10m',
    'Arrival type': 'Evening',
    'Flight date finish': '11/30/24',
    'My Price': '189',
    'Last Scan': '15/04/2020',
    'Cabin baggage price': '25$',
    'Checked baggae price': '90$',
    Aircraft: 'Airbus A320-100/200',
  },
  {
    Competitor: 'EasyJet',
    'Flight name': 'TLV - AMS',
    'Origin Airport': 'Ben Gurion Intl',
    'Destination Airport': 'AMS Amsterdam',
    'Origin city': 'Tel-aviv',
    'Destination City': 'Amsterdam',
    'Origin country': 'Israel',
    'Destination country': 'Netherlands',
    'Flight ID': 'EZY7934',
    'Flight due date': '12/7/24',
    'Departure time': '2:00 pm',
    'Arrival time': '6:10 pm',
    'Flight Duration': '5h 10m',
    'Arrival type': 'Evening',
    'Flight date finish': '12/7/24',
    'My Price': '198',
    'Last Scan': '15/04/2020',
    'Cabin baggage price': '25$',
    'Checked baggae price': '90$',
    Aircraft: 'Airbus A320-100/200',
  },
  {
    Competitor: 'Wizz-Air',
    'Flight name': 'TLV - WAW',
    'Origin Airport': 'Ben Gurion Intl',
    'Destination Airport': 'Warsaw Chopin',
    'Origin city': 'Tel-aviv',
    'Destination City': 'Warsaw',
    'Origin country': 'Israel',
    'Destination country': 'Polland',
    'Flight ID': 'W61560',
    'Flight due date': '11/29/24',
    'Departure time': '7:50 pm',
    'Arrival time': '10:50 pm',
    'Flight Duration': '4h',
    'Arrival type': 'Evening',
    'Flight date finish': '11/29/24',
    'My Price': '78',
    'Last Scan': '15/04/2020',
    'Cabin baggage price': '25$',
    'Checked baggae price': '90$',
    Aircraft: 'Airbus A321neo',
  },
  {
    Competitor: 'Wizz-Air',
    'Flight name': 'TLV - WAW',
    'Origin Airport': 'Ben Gurion Intl',
    'Destination Airport': 'Warsaw Chopin',
    'Origin city': 'Tel-aviv',
    'Destination City': 'Warsaw',
    'Origin country': 'Israel',
    'Destination country': 'Polland',
    'Flight ID': 'W61560',
    'Flight due date': '12/3/24',
    'Departure time': '7:50 pm',
    'Arrival time': '10:50 pm',
    'Flight Duration': '4h',
    'Arrival type': 'Evening',
    'Flight date finish': '12/3/24',
    'My Price': '78',
    'Last Scan': '15/04/2020',
    'Cabin baggage price': '25$',
    'Checked baggae price': '90$',
    Aircraft: 'Airbus A321neo',
  },
  {
    Competitor: 'Wizz-Air',
    'Flight name': 'TLV - BUD',
    'Origin Airport': 'Ben Gurion Intl',
    'Destination Airport': 'BUD Budapest',
    'Origin city': 'Tel-aviv',
    'Destination City': 'Budapest',
    'Origin country': 'Israel',
    'Destination country': 'Hungary',
    'Flight ID': 'W62326',
    'Flight due date': '11/29/24',
    'Departure time': '11:10 am',
    'Arrival time': '1:35 pm',
    'Flight Duration': '3h 25m',
    'Arrival type': 'Noon',
    'Flight date finish': '11/29/24',
    'My Price': '78',
    'Last Scan': '15/04/2020',
    'Cabin baggage price': '25$',
    'Checked baggae price': '90$',
    Aircraft: 'Airbus A321neo',
  },
  {
    Competitor: 'Wizz-Air',
    'Flight name': 'TLV - BUD',
    'Origin Airport': 'Ben Gurion Intl',
    'Destination Airport': 'BUD Budapest',
    'Origin city': 'Tel-aviv',
    'Destination City': 'Budapest',
    'Origin country': 'Israel',
    'Destination country': 'Hungary',
    'Flight ID': 'W62328',
    'Flight due date': '11/29/24',
    'Departure time': '9:40 pm',
    'Arrival time': '11:55 pm',
    'Flight Duration': '3h 15m',
    'Arrival type': 'Evening',
    'Flight date finish': '11/29/24',
    'My Price': '67',
    'Last Scan': '15/04/2020',
    'Cabin baggage price': '25$',
    'Checked baggae price': '90$',
    Aircraft: 'Airbus A320-100/200',
  },
  {
    Competitor: 'Wizz-Air',
    'Flight name': 'TLV - BUD',
    'Origin Airport': 'Ben Gurion Intl',
    'Destination Airport': 'BUD Budapest',
    'Origin city': 'Tel-aviv',
    'Destination City': 'Budapest',
    'Origin country': 'Israel',
    'Destination country': 'Hungary',
    'Flight ID': 'W62330',
    'Flight due date': '12/3/24',
    'Departure time': '4:35 pm',
    'Arrival time': '7:00 pm',
    'Flight Duration': '3h 25m',
    'Arrival type': 'Evening',
    'Flight date finish': '12/3/24',
    'My Price': '67',
    'Last Scan': '15/04/2020',
    'Cabin baggage price': '25$',
    'Checked baggae price': '90$',
    Aircraft: 'Airbus A320-100/200',
  },
  {
    Competitor: 'Wizz-Air',
    'Flight name': 'BUD - TLV',
    'Origin Airport': 'BUD Budapest',
    'Destination Airport': 'Ben Gurion Intl',
    'Origin city': 'Budapest',
    'Destination City': 'Tel-aviv',
    'Origin country': 'Hungary',
    'Destination country': 'Israel',
    'Flight ID': 'W62325',
    'Flight due date': '11/29/24',
    'Departure time': '6:00 am',
    'Arrival time': '10:15 am',
    'Flight Duration': '3h 15m',
    'Arrival type': 'Morning',
    'Flight date finish': '11/29/24',
    'My Price': '67',
    'Last Scan': '15/04/2020',
    'Cabin baggage price': '25$',
    'Checked baggae price': '90$',
    Aircraft: 'Airbus A321neo',
  },
  {
    Competitor: 'Wizz-Air',
    'Flight name': 'LTN - TLV',
    'Origin Airport': 'London Luton',
    'Destination Airport': 'Ben Gurion Intl',
    'Origin city': 'London',
    'Destination City': 'Tel-aviv',
    'Origin country': 'United kingdom',
    'Destination country': 'Israel',
    'Flight ID': 'W94451',
    'Flight due date': '12/6/24',
    'Departure time': '1:45 pm',
    'Arrival time': '8:55 pm',
    'Flight Duration': '5h 10m',
    'Arrival type': 'Evening',
    'Flight date finish': '12/6/24',
    'My Price': '142',
    'Last Scan': '15/04/2020',
    'Cabin baggage price': '25$',
    'Checked baggae price': '90$',
    Aircraft: 'Airbus A320-100/200',
  },
  {
    Competitor: 'EasyJet',
    'Flight name': 'LTN - TLV',
    'Origin Airport': 'London Luton',
    'Destination Airport': 'Ben Gurion Intl',
    'Origin city': 'London',
    'Destination City': 'Tel-aviv',
    'Origin country': 'United kingdom',
    'Destination country': 'Israel',
    'Flight ID': 'EZY2085',
    'Flight due date': '12/6/24',
    'Departure time': '11:40 am',
    'Arrival time': '6:40 pm',
    'Flight Duration': '5h',
    'Arrival type': 'Evening',
    'Flight date finish': '12/6/24',
    'My Price': '142.18',
    'Last Scan': '15/04/2020',
    'Cabin baggage price': '25$',
    'Checked baggae price': '90$',
    Aircraft: 'Airbus A320-100/200',
  },
  {
    Competitor: 'EasyJet',
    'Flight name': 'CDG - TLV',
    'Origin Airport': 'Paris Charles de Gaulle',
    'Destination Airport': 'Ben Gurion Intl',
    'Origin city': 'Paris',
    'Destination City': 'Tel-aviv',
    'Origin country': 'France',
    'Destination country': 'Israel',
    'Flight ID': 'EZY3737',
    'Flight due date': '12/6/24',
    'Departure time': '12:40 pm',
    'Arrival time': '6:15 pm',
    'Flight Duration': '4h 35m',
    'Arrival type': 'Evening',
    'Flight date finish': '12/6/24',
    'My Price': '183.29',
    'Last Scan': '15/04/2020',
    'Cabin baggage price': '25$',
    'Checked baggae price': '90$',
    Aircraft: 'Airbus A321-100/200',
  },
  {
    Competitor: 'EasyJet',
    'Flight name': 'AMS - TLV',
    'Origin Airport': 'AMS Amsterdam',
    'Destination Airport': 'Ben Gurion Intl',
    'Origin city': 'Amsterdam',
    'Destination City': 'Tel-aviv',
    'Origin country': 'Netherlands',
    'Destination country': 'Israel',
    'Flight ID': 'EZY7933',
    'Flight due date': '12/4/24',
    'Departure time': '7:15 am',
    'Arrival time': '1:00 pm',
    'Flight Duration': '4h 45m',
    'Arrival type': 'Noon',
    'Flight date finish': '12/6/24',
    'My Price': '168',
    'Last Scan': '15/04/2020',
    'Cabin baggage price': '25$',
    'Checked baggae price': '90$',
    Aircraft: 'Airbus A320-100/200',
  },
  {
    Competitor: 'Wizz-Air',
    'Flight name': 'WAW - TLV',
    'Origin Airport': 'Warsaw Chopin',
    'Destination Airport': 'Ben Gurion Intl',
    'Origin city': 'Warsaw',
    'Destination City': 'Tel-aviv',
    'Origin country': 'Polland',
    'Destination country': 'Israel',
    'Flight ID': 'W61559',
    'Flight due date': '12/6/24',
    'Departure time': '2:05 pm',
    'Arrival time': '6:55 pm',
    'Flight Duration': '3h 50m',
    'Arrival type': 'Evening',
    'Flight date finish': '12/6/24',
    'My Price': '63',
    'Last Scan': '15/04/2020',
    'Cabin baggage price': '25$',
    'Checked baggae price': '90$',
    Aircraft: 'Airbus A321neo',
  },
];
